import { RegisterImages, NeonImageRegistry } from '@art-basel/artbasel-lib-neon';
import uploadImagesVideosIllustration from '@/images/imagesVideosUploadIllustration.svg';
import ubsLogo from '@/images/ubsLogo.svg';

export const initIcons = () => {
  RegisterImages.register();
  NeonImageRegistry.imageRegistry.addImage('upload-images-and-videos-illustration', uploadImagesVideosIllustration);
  NeonImageRegistry.imageRegistry.addImage('ubs-logo', ubsLogo);
};
